import React from "react";
import { Grid, Card,  Container, Typography, Stack} from '@mui/material';
import FormManager from "../../../components/formComponents/FormManager";
import schema from './schema.json';
import HTTPManager from "../../../utils/httpRequestManager";
import TableView from '../../../components/table/tableView';
import { toast, ToastContainer } from 'react-toastify';
import FButton from '../../../components/formComponents/components/button';
import Page from '../../../components/Page';
import Loader from '../../../components/Loader';
import Iconify from '../../../components/Iconify';
import { checkButtonAccess } from "../../../utils/protector";

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

export default class Region extends React.Component{
    httpManager = new HTTPManager();

    constructor(){
        super();
        this.state={
            schema:{},
            regionsList:[],
            addForm: false,
            isLoading: false, 
            columns:[
                // {
                // field: 'region_name',
                // headerName: 'Name',
                // minWidth: 200,
                // editable: false,
                // renderCell: (params) => (
                //     <div>
                //         {params.row.regionName}
                //     </div>
                // )
                // },
                {
                    field: 'code',
                    headerName: 'Code',
                    maxWidth: 200,
                    flex:1,
                    editable: false,
                    renderCell: (params) => (
                        <div>
                            {params.row.regionCode === '' || params.row.regionCode === null? '--': params.row.regionCode}
                        </div>
                    )
                },
                {
                    field: 'states',
                    headerName: 'States',
                    minWidth: 400,
                    flex:1,
                    editable: false,
                    renderCell: (params) => {

                        var statenames = params.row.regionStates.map(s=>s.stateName)
                        return <div>
                            {statenames.length === 0? '--': statenames.join(", ")}
                        </div>
                    }
                },
                
                // {
                // field: 'states',
                // headerName: 'States',
                // minWidth: 150,
                // editable: false,
                // renderCell: (params) => (
                //     <div style={{textTransform:'capitalize'}}>
                //         {params.row.states.forEach((s,i)=>{
                //             if(i<params.row.states.length){
                //                 return s+",";
                //             }
                //         })}
                //     </div>
                // )
                // },
                {
                field: 'Action',
                headerName:'Actions',
                minWidth:150,
                flex:1,
                renderCell: (params) => (
                    <strong>  
                        {params.row.isDefault !== '1' && checkButtonAccess('Region') === 'W' &&
                            <FButton permission_id = "web_edit_region" permission_label="Show edit region"
                            variant="outlined" 
                            size="small" 
                            onClick={()=>this.openEdit(params.row)} 
                            label="Edit"/>
                        }  
                        {(params.row.isDefault === '1' || checkButtonAccess('Region') !== 'W') && <div style={{margin:'0 8px'}}>N/A</div>}          
                    {/* {params.row.regionStatus===1 &&  
                        <FButton permission_id = "web_status_region" permission_label="Show status region"
                        variant="contained" 
                        size="small" 
                        onClick={()=>{this.updateRecord(params.row, 0)}} 
                        label="Deactivate"/>
                    }
                    {params.row.regionStatus!==1 &&  
                        <FButton permission_id = "web_status_region" permission_label="Show status region"
                        variant="contained" 
                        size="small" 
                        onClick={()=>{this.updateRecord(params.row, 1)}} 
                        label="Activate"/>
                    } */}
                    </strong>
                    
                ),
                },
            ],
            selectedRegion:{}
        }

        this.reloadData = this.reloadData.bind(this);
        this.onRegionNameChange = this.onRegionCodeChange.bind(this);
        this.onStateChange = this.onStateChange.bind(this);
    }

    onStateChange(data){
        //console.log("STATE CHANGE CALLED")
        // var schema = Object.assign({}, this.state.schema);
        // var properties = Object.assign([], this.state.schema.properties);
        // var props=[];
        // properties.forEach((field,i)=>{  
        //     if(field === '')
        // });
    }

    updateRecord(row, status){
        this.setState({isLoading: true}, ()=>{
            this.httpManager.postRequest(`region/updateRegion`, {regionStatus: status, id: row.id}).then(res=>{
                //console.log(res.message);
                this.setState({isLoading: false});
                this.reloadData(res.message);
            })
        })
    }

    onRegionCodeChange(val){ 
    }

    componentDidMount(){ 
        this.setState({schema: schema},()=>{

        });
        this.reloadData();
    }

    getManagedRegions(){
        var props = Object.assign([], this.state.schema.properties);
        var properties = [];
        props.forEach((field, i)=>{
            if(field.name !== 'manageregions'){
                properties.push(field)
            }
            if(i === props.length-1){
                properties.push( 
                    {
                      "component":"Checkbox", 
                      "type": "text",
                      "format":"string",
                      "minLength": 1,
                      "maxLength": 50,
                      "grid":12,
                      "checkboxWidth":"100%",
                      "name":"manageregions",
                      "label":"Regions to Manage:",
                      "placeholder":"Regions to Manage:",
                      "data":"region/getRegionsToManage",
                      "emptyMsg":"No Regions found.",
                      "dataformat":{
                          "label":"regionCode",
                          "value":"id"
                      },
                      "value":[]
                    }  
                )
                var schema = Object.assign({}, this.state.schema);
                schema.properties = properties;
                this.setState({schema: schema})
            }
        })
    }

    openEdit(data){
        //console.log(data)
        var schema = Object.assign({}, this.state.schema);
        var propslist = Object.assign([], this.state.schema.properties);
        var properties = [];
        propslist.forEach((elmt,i)=>{
            if(elmt.name !== 'manageregions' && elmt.name !== 'states'){ 
                properties.push(elmt);
            }
            if(elmt.name === 'states'){
                elmt.data = "/lookup/getStatesForRegion/"+data.id;
                properties.push(elmt);
            }
            if(i === propslist.length-1){
                if(data.regionStates !== undefined){
                    if(data.regionStates.length >0){
                        var states = data.regionStates.map(s=>s.stateId);
                        data.states = states;
                    }
                }
                else{
                    data.states = [];
                }

                if(data.managedRegions !== undefined){
                    if(data.managedRegions.length >0){
                        var subregions = data.managedRegions.map(s=>s.subRegionId);
                        data.manageregions = subregions;
                    }
                }
                else{
                    data.manageregions = [];
                }

                properties.push( 
                    {
                      "component":"Checkbox", 
                      "type": "text",
                      "format":"string",
                      "minLength": 1,
                      "maxLength": 50,
                      "grid":12,
                      "checkboxWidth":"100%",
                      "name":"manageregions",
                      "label":"Regions to Manage:",
                      "placeholder":"Regions to Manage:",
                      "emptyMsg":"No Regions found.",
                      "data":"region/getRegionsToManage/"+data.id,
                      "dataformat":{
                          "label":"regionCode",
                          "value":"id"
                      },
                      "value":data.managedRegions
                    }  
                )
                var props=[];
                properties.forEach((field,i)=>{
                    field.value = data[field.name];
                    props.push(field);
                    if(i === properties.length-1){
                        props.push({
                            "component":"TextField", 
                            "type": "hidden", 
                            "minLength": 1,
                            "maxLength": 50,
                            "grid":6,
                            "name":"id",
                            "label":"id",
                            "placeholder":"id",
                            "value":data.id
                          })
                        schema.properties = props; 
                        this.setState({schema: schema,selectedRegion: data},()=>{
                            this.setState({addForm: true})
                        })
                    }
                })
            }
        })
    }

    reloadData(msg=''){
        if(msg !== ''){ 
            toast.dismiss();
            toast.success(msg, {
                position: "top-center",
                autoClose: 5000,
                closeButton:false,
                hideProgressBar: true,
                closeOnClick: false,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }
        this.setState({isLoading: true, addForm: false},()=>{
            this.httpManager.getRequest(`region/getRegions`).then(response=>{
                //console.log(response)
                this.setState({regionsList: response.data, isLoading: false});
            })
        })
    }

    openAdd(){

        this.setState({schema: schema,selectedRegion: {}},()=>{
            var schemaobj = Object.assign({}, schema);

            var properties = Object.assign([], this.state.schema.properties);
            var props=[];
            properties.forEach((field,i)=>{
                delete field["value"];
                props.push(field);
                if(i === properties.length-1){
                    schemaobj.properties = props;
                }
            });
            this.setState({schema:schemaobj}, ()=>{
                this.setState({addForm: true}) 
                this.getManagedRegions()
            })
        }) 
    }

    handleCloseform(msg){
        this.setState({addForm:false})
    }

    render(){
        return <Page title="Region | Astro POS">
        {this.state.isLoading && <Loader show={this.state.isLoading} />}
            <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar
            newestOnTop={false}
            closeOnClick={false}
            rtl={false}
            pauseOnFocusLoss={false}
            draggable={false}
            pauseOnHover={false}
            />

{!this.state.addForm ? 
        <Container maxWidth="xl">
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
            <Typography variant="h4" gutterBottom>
              Region Management
            </Typography>
           {checkButtonAccess('Region') === 'W' && <FButton permission_id = "web_add_region" permission_label="Show add region"
              onClick={()=>this.openAdd()}
              size="large"
              variant="contained"
              label="Add Region"
              startIcon={getIcon('mdi:plus')}
            />}
          </Stack>

          <Card>
              <TableView
                name="region"
                permission_id = "web_view_region" 
                permission_label="Show view region"
                data={this.state.regionsList} 
                columns={this.state.columns} />
          </Card>
        </Container> : ''
        }
        {this.state.addForm && 
            <Container maxWidth="xl">
               
                <Grid container spacing={3}  alignItems="center"  justifyContent="center" style={{marginLeft:0, marginRight:0,width:'100%', fontWeight:'bold'}} > 
                    {/* <Grid item xs={1}></Grid> */}
                    <Grid item xs={12}> 
                        <Stack spacing={3}> 
                            <FormManager formProps={this.state.schema} formFunctions={{
                                onStateChange: this.onStateChange,
                                onRegionNameChange: this.onRegionNameChange
                            }}  reloadData={()=>this.reloadData()} closeForm={()=>this.handleCloseform()}/>
                        </Stack>
                    </Grid>
                    {/* <Grid item xs={1}></Grid>  */}
                </Grid>
              
            </Container>
        }
        </Page>
    }
}